import { Text } from '@chakra-ui/react';
import { NavGroup, NavItem, SidebarSection } from '@saas-ui/react';
import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { LinkItemProps } from './SidebarLayout.types';

export default function SidebarBody({
  links,
  isOpen,
}: {
  links: Array<LinkItemProps>;
  isOpen: boolean;
}) {
  const location = useLocation();

  const renderItem = (item: LinkItemProps) => {
    if (item.kind === 'subheader') {
      return (
        <Fragment key={item.name}>
          <Text px={3} pt={3} pb={1} fontSize="xs" fontWeight="medium" color="gray.500">
            {item.name.toUpperCase()}
          </Text>
          {item.children?.filter((child) => !child.hide).map(renderItem)}
        </Fragment>
      );
    }

    if (item.disabled) {
      return (
        <NavItem key={item.name} aria-disabled opacity={0.5} cursor="not-allowed">
          {item.name}
        </NavItem>
      );
    }

    if (item.href) {
      return (
        <NavItem as="a" href={item.href} key={item.href}>
          {item.name}
        </NavItem>
      );
    }

    return (
      <NavItem
        as={Link}
        to={item.to!}
        key={item.to}
        isActive={location.pathname.startsWith(`/${item.to}`)}
      >
        {item.name}
      </NavItem>
    );
  };

  return (
    <SidebarSection flex="1" overflowY="auto">
      {links
        .filter((link) => !link.hide)
        .map((link) => {
          // Is a submenu
          if (link.children) {
            const SectionIcon = link.icon;
            return (
              <NavGroup
                title={link.name}
                key={link.name}
                icon={SectionIcon ? <SectionIcon aria-hidden={true} /> : undefined}
                isCollapsible={isOpen}
              >
                {link.children.filter((child) => !child.hide).map(renderItem)}
              </NavGroup>
            );
          }

          if (link.href) {
            return (
              <NavItem as="a" href={link.href} key={link.href}>
                {link.name}
              </NavItem>
            );
          }

          return (
            <NavItem
              as={Link}
              isActive={location.pathname.startsWith(`/${link.to}`)}
              to={link.to!}
              key={link.to}
            >
              {link.name}
            </NavItem>
          );
        })}
    </SidebarSection>
  );
}
